<script lang="ts">
    
    import { createEventDispatcher, onMount } from "svelte";
    import type { HistoricSearchParams } from "../../global";
    import type { Form } from "../../Model/Form";
    import { formsService, usersService } from "../../services";
    import type { User } from "../../Model/User";

    export let isSearching = false;

    const dispatch = createEventDispatcher();

    let formId = '';
    let userId = '';
    let formText = '';
    let completedFrom = '';
    let completedUntil = '';
    let isDownloaded = undefined;
    let productionForms: Form[] = [];
    let archivedForms: Form[] = [];
    let users: User[] = [];

    onMount(() => {
        getForms();
        getUsers();
    });

    async function getForms(): Promise<void> {
        try {
            const allForms = await formsService.findForms(0, 1000);
            const archived: Form[] = [];
            const production: Form[] = [];
            allForms
                .sort((a, b) => a.name < b.name ? -1 : 1)
                .forEach(form => {
                    if (!form.name) {
                        form.name = '-- Formulario sin nombre --';
                    }
                    if (form.disabled) {
                        return
                    }
                    if (!form.status) {
                        archived.push(form);
                    } else if (form.production) {
                        production.push(form);
                    }
                });
            productionForms = production;
            archivedForms = archived;
        } catch (error) {
            console.error(error);
        }
    }

    async function getUsers(): Promise<void> {
        try {
            const preUsers = await usersService.findUsers(0, 1000);

            users = preUsers.filter(user => user.rol_id === 3);
            
        } catch (error) {
            console.error(error);
        } 
    }

    function onSubmit(): void {
        if (isSearching) {
            return;
        }

        const searchParams: HistoricSearchParams = {
            formId,
            userId,
            formText,
            completedFrom,
            completedUntil,
            isDownloaded,
        };

        dispatch('search', searchParams);
    }

</script>

<form novalidate on:submit|preventDefault={onSubmit} class="d-flex gap-2 align-items-end">

    <div class="form-group">
        <!-- svelte-ignore a11y-label-has-associated-control-->
        <label>Nombre</label>
        <input type="text" class="form-control" bind:value={formText}>

    </div>

    <div class="form-group">
        <!-- svelte-ignore a11y-label-has-associated-control-->
        <label>Formulario</label>
        <select class="form-select" bind:value={formId}>
            <option value="">-</option>
            {#if productionForms.length}    
                <optgroup label="Producción">
                    {#each productionForms as form}
                        <option value={form.id}>{form.name}</option>
                    {/each}
                </optgroup>
            {/if}
            {#if archivedForms.length}    
                <optgroup label="Archivados">
                    {#each archivedForms as form}
                        <option value={form.id}>{form.name}</option>
                    {/each}
                </optgroup>
            {/if}
        </select>
    </div>
    
    <div class="form-group">
        <!-- svelte-ignore a11y-label-has-associated-control-->
        <label>Miembros</label>
        <select class="form-select" bind:value={userId}>
            <option value="">-</option>
            {#if users.length}    
                {#each users as user}
                    <option value={user.id}>{user.name}</option>
                {/each}
            {/if}
        </select>
    </div>


    <div class="form-group">
        <!-- svelte-ignore a11y-label-has-associated-control-->
        <label>Fecha completado (desde / hasta)</label>
        <div class="d-flex gap-2">
            <input type="date" class="form-control" bind:value={completedFrom}>
            <input type="date" class="form-control" bind:value={completedUntil}>
        </div>
    </div>

    <div class="form-group">
        <!-- svelte-ignore a11y-label-has-associated-control-->
        <label>Descargado</label>
        <select class="form-select" bind:value={isDownloaded}>
            <option value={undefined}>-</option>
            <option value={true}>Sí</option>
            <option value={false}>No</option>
        </select>
    </div>

    <div class="d-flex flex-grow-1"></div>

    <button type="submit" class="btn btn-primary" disabled={isSearching}>
        {#if isSearching}
            Buscando...
        {:else}
            Buscar
        {/if}
    </button>

</form>
